export const DASHBOARD = '/dashboard';
export const DASHBOARD_PARAMS = '/:community?';
export const MANAGE_MEMBERS = '/manage_members';
export const BRANDING = '/branding';
export const MANAGE_IN_APP_MESSAGING = '/manage_in_app_messaging';
export const CODE_VALIDATIONS = '/code_validations';
export const SETTINGS = '/settings';
export const NOT_FOUND = '/404';
export const LANDING = '/';
